import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatCalendarHeader } from '@angular/material/datepicker';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'app-range-months-header',
    templateUrl: './range-months-header.component.html',
    styleUrls: ['./range-months-header.component.scss'],
    standalone: false
})
export class RangeMonthsHeaderComponent extends MatCalendarHeader<Date> {
  get label() {
    return super.periodButtonText;
  }
}
